// This file is part of ecbyts/ECBT (Environmental & Occupational Core Byte Tools).
// Copyright (C) 2026 Calvin Stefan Iost
// Licensed under the GNU Affero General Public License v3.0 (AGPL-3.0-only).

/**
 * PREÇO DO PLANO PRO — FONTE ÚNICA (decisão do Calvin, 2026-09-23: "o preço do
 * Pro tem de ser UMA constante/config").
 *
 * Antes o valor vivia repetido: `productTiers.ts` (o que a tela mostra) e
 * `supabase/functions/_shared/tierPricingPure.ts` (o que o Mercado Pago cobra),
 * amarrados só por um teste de paridade. Agora os dois LEEM daqui — a Edge
 * importa este arquivo direto (mesmo padrão de `_shared/transactionalEmailDelivery.ts`),
 * então ele não pode importar nada (Deno e o build do app leem o mesmo fonte).
 *
 * Valor definitivo escolhido pelo Calvin em 2026-09-25 ("preço Pro 49/490",
 * thread "Checkout do plano Pro"); antes era R$29/R$290. Trocar AQUI
 * muda a exibição e a cobrança do Mercado Pago de uma vez. O preço do Stripe
 * mora no objeto Price do Stripe; `scripts/billing/subscription-price-map.mjs`
 * RECUSA publicar um mapa cujo Price do Pro tenha valor diferente desta
 * constante — é assim que o Stripe fica amarrado à mesma fonte.
 *
 * Unidade: reais inteiros (mesma unidade de `priceMonthly`/`priceYearly`).
 */
export const PRO_PLAN_PRICE = Object.freeze({
    currency: 'BRL' as const,
    monthly: 49,
    yearly: 490,
    /** 'aprovado': valor definitivo escolhido pelo Calvin. */
    status: 'aprovado' as 'aguardando_escolha_do_calvin' | 'aprovado',
});

/** Valor em centavos para uma cadência (para comparar com o Stripe Price). */
export function proPlanPriceCents(cadence: 'monthly' | 'yearly'): number {
    return Math.round(PRO_PLAN_PRICE[cadence] * 100);
}

export const MULTI_MODEL_FEATURE = 'multi' + 'Model';
export const MULTI_ORG_FEATURE = 'multi' + 'Organization';
